"use strict";

(function ($) {
  $.fn.stuckNav = function () {
    var $that = $(this),
        h = $that.outerHeight(),
        top = $that.offset().top,
        $li = $that.find('li'),
        $underline = $that.find('.js-underline'),
        $first = $li.first();
    $underline.css({
      'left': $first.offset().left,
      'bottom': '0px',
      'opacity': '0'
    });

    function changeActive(li) {
      li.each(function () {
        if ($(this).hasClass('active')) {
          $underline.css({
            'left': $(this).offset().left,
            'width': $(this).width(),
            'opacity': '1'
          });
        }
      });
    }

    $window.on('resize', function (e) {
      h = $that.outerHeight();
      $li = $that.find('li');
      top = $that.offset().top;
      changeActive($li);
    });
    return $window.on('scroll', function (e) {
      e.preventDefault();
      changeActive($li);

      if (top < wt + hh) {
        $that.addClass('is-stuck');
        $body.addClass('section-nav-stuck');
        $that.css('height', h);
      } else {
        $that.removeClass('is-stuck');
        $body.removeClass('section-nav-stuck');
      }
    });
  };
})(jQuery);

$(function () {
  if ($('.js-section-nav').length) {
    $('.js-section-nav').stuckNav();
  }
});